import { useHistory, useLocation } from "react-router-dom";

export const useQueryParamChange = () => {
  const history = useHistory();
  const location = useLocation();

  return (key: string, value: string) => {
    const urlParams = new URLSearchParams(location.search);
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
};
